import { Injectable, OnDestroy } from '@angular/core';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { BehaviorSubject, from, Observable, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable()
export class PwaService implements OnDestroy {

  public promptEvent: any;
  private readonly serviceSubscriptions: Subscription[] = [];
  public $isAnyNewUpdateAvailable: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private versionCheckInterval: any;

  constructor(private swUpdate: SwUpdate, private swPush: SwPush, private eventBus: AmdocsEventBusService, private apiService: ApiService,) {
    swUpdate?.versionUpdates.subscribe(event => {
      if (event.type === 'VERSION_READY') {
        console.log('new version exists!');
        this.$isAnyNewUpdateAvailable.next(true);
      }
    });
    this.swUpdate.checkForUpdate();

    // Check for updates every 15 seconds
    this.versionCheckInterval = setInterval(() => {
      this.swUpdate.checkForUpdate();
    }, 15000);

    /**
     * save the beforeinstall event in order to prompt it once the user clicked the add to device
     */
    window.addEventListener('beforeinstallprompt', event => {
      console.log('inside event beforeinstallprompt');
      this.promptEvent = event;
    });
    window.addEventListener('appinstalled', (event) => {
      console.log('app installed');
    });


  }


  subscribeToNotifications(): void {
    this.swPush.requestSubscription({
      serverPublicKey: environment.pushPublicKey
    })
      .then(sub => {
        localStorage.setItem('subscribe-to-notification-popup', '1');
        console.log('sub', sub);
      })
      .catch(err => {
        console.log('err', err);
      });
  }

  listenPushNotifications(): void {
    this.swPush.messages.subscribe((message) => {console.log('message', message); });
  }

  public registerToPush(): void {
    navigator.serviceWorker.ready.then(
      (serviceWorkerRegistration) => {
        const options = {
          userVisibleOnly: true,
          applicationServerKey: environment.pushPublicKey
        };
        serviceWorkerRegistration.pushManager.subscribe(options).then(
          (pushSubscription) => {
            const response = JSON.parse(JSON.stringify(pushSubscription));
            delete response.expirationTime;
            this.apiService.subscribeToPushNotifications(response).subscribe();
          }, (error) => {
            console.error('Could not subscribe to notifications', error.message);
          }
        );
      });
  }

  public unregisterFromPush(): void {
    navigator.serviceWorker.ready.then((reg) => {
      reg.pushManager.getSubscription().then((subscription) => {
        const subscriptionObject = JSON.parse(JSON.stringify(subscription));
        if (subscription) {
          subscription.unsubscribe().then((successful) => {
            console.log(successful);
            this.apiService.unsubscribeFromPushNotifications(subscriptionObject.keys.auth).subscribe();
          }).catch((e) => {
            console.log('unsubscribe error ', e.message);
          });
        }
      });
    });
  }
  userGrantedPushNotifications(): boolean {
    return Notification.permission === 'granted';
  }

  hasPushSubscription(): Observable<boolean> {
    return from(navigator.serviceWorker.ready.then((reg) => {
      return reg.pushManager.getSubscription().then((subscription) => {
        return subscription !== null;
      });
    }));
  }

        async clearCachesAndReload(addReloadQueryParam: boolean = true): Promise<void> {

        try {
                const cacheKeys = await caches.keys();
                await Promise.all(cacheKeys.map(k => caches.delete(k)));

        } catch (err) {
            console.log('[ServiceWorkerService] Failed clearing caches', err);
        } finally {
            // Preserve existing cleanUrl logic used elsewhere
            localStorage.setItem('cleanUrl', 'true');
            const basePath = window.location.pathname;
            if (addReloadQueryParam) {
                window.location.href = basePath + '?reload=' + new Date().getTime();;
            } else {
                // Using replace avoids creating extra history entry
                window.location.replace(basePath);
            }
        }
    }

   ngOnDestroy(): void {
        if (this.versionCheckInterval) {
            clearInterval(this.versionCheckInterval);
        }
        this.serviceSubscriptions?.forEach(x => x?.unsubscribe());
    }
}
